export default {
  'zh-hk': {
    common: {
      save: '保存',
      saveSuccess: '保存成功',
      requestSuccess: '請求成功',
      ok: '確定',
      cancel: '取消',
      submit: '提交',
      tip: '提示'
    },
    errors: {
      notEmpty: {
        pwd: '密碼不能爲空。',
        queueRequestURL: '請先掃描二維碼。',
        insurance: '請選擇保險。',
        qrCode: '二維碼錯誤。'
      }
    },
    auth: {
      login: '登錄',
      username: '用戶名',
      staffNo: '職員編號',
      password: '密碼',
      signIn: '登錄',
      remeber: '記住帳號',
      reScan: 'Branch code 遺失，請重新掃描二維碼'
    },
    home: {
      queueRequest: '排隊',
      scanQRCode: '掃描二維碼',
      queueType: '類型',
      company: '公司',
      normal: '普通',
      selectIns: '選擇保險',
      validation: '驗證',
      inputPwd: '請輸入密碼',
      confirm: '是否提交排隊？'
    },
    profile: {
      title: '個人中心',
      firstName: '名',
      lastName: '姓',
      name: '姓名',
      alias: '別名',
      gender: '性別',
      ic: '身份證',
      birthday: '生日',
      postal: '郵編',
      address: '地址',
      maritalStatus: '婚姻狀態',
      nationality: '國籍',
      country: '國家',
      language: '語言',
      race: '種族',
      religion: '宗教',
      changePwd: '修改密碼',
      signOut: '退出登錄',
      confirmSignOut: '確定要退出登錄嗎?'
    }
  }
}
